export enum Role {
  Student = 0,
  PeerAdvisor = 1,
  Advisor = 3,
  Generalist = 7,
  Executive = 15,
  Administrator = 31,
  Support = 63,
}

export const RoleToString = (x: Role) => {
  switch (x) {
    case Role.Student:
      return 'Student';
    case Role.PeerAdvisor:
      return 'Peer Advisor';
    case Role.Advisor:
      return 'Advisor';
    case Role.Generalist:
      return 'Generalist';
    case Role.Executive:
      return 'Executive';
    case Role.Administrator:
      return 'Administrator';
    case Role.Support:
      return 'Support';
    default:
      return '';
  }
};
